
import { createSlice } from "@reduxjs/toolkit";

import { fetchHistoryListData } from "../thunks/clientHistoryThunk";





interface CompanyListState {
  historyList: any[] | null;
  loading: boolean;
  error: string | null;
}

const initialState: CompanyListState = {
    historyList: [], 
    loading: false,
    error: null,
};


export const phoneListSlice = createSlice({
  name: "historyList",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchHistoryListData.pending, (state) => { 
        state.loading = true;
      })
      .addCase(fetchHistoryListData.fulfilled, (state, action) => {
        state.historyList = action.payload || [];
        state.loading = false;
      })
      .addCase(fetchHistoryListData.rejected, (state, action) => { 
        state.error = action.payload as string;
        state.loading = false;
      });
  },
});

export default phoneListSlice.reducer;
